import type { CSSProperties } from 'react';

/**
 * Варианты размера страницы в пагинации таблицы.
 *
 * Один список на все представления: обычное и групповое. Дублирование литералом
 * приводило к тому, что при включении группировки селектор «строк на странице»
 * незаметно менял набор значений.
 */
export const PAGE_SIZE_OPTIONS: readonly number[] = [25, 50, 100, 500];

/**
 * Отступ дочерней строки дерева, px на уровень вложенности.
 *
 * Общий для обоих деревьев таблицы — серверной группировки (`groupBy`) и
 * раскрываемых строк (`subRows`): одинаковая вложенность должна выглядеть
 * одинаково, где бы её ни включили.
 */
export const TREE_DEPTH_INDENT = 22;

/**
 * Место под шеврон в ключевой колонке дерева. Корневые строки без детей
 * получают такой же отступ, иначе их подписи «прыгали» бы относительно
 * подписей раскрываемых соседей.
 */
export const TREE_TOGGLE_WIDTH = 20;

/**
 * Обёртки ячейки ключевой колонки дерева (отступ под шеврон, шеврон, уголок
 * подстроки) занимают всю ширину ячейки. Ячейка — flex-строка с
 * `white-space: nowrap`: без этого обёртка растёт по тексту, и содержимое с
 * `width: 100%` (например, флажки в углу ячейки) меряется от длины текста, а не
 * от ширины поля — у длинных названий уезжает за край.
 */
export const TREE_CELL_FILL = { flex: 1, minWidth: 0 } satisfies CSSProperties;
